import { Col, Row } from "react-bootstrap";
import PageTitle from "../../components/Ui/PageTitle";
import React, { Fragment, useEffect } from "react";
import { selectUser } from "../../store/selectors/UserSelectors";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { UserType } from "../../entities/User";
import OrderList from "../../components/OrderList/index";
import OrderBrowser from "../../components/OrderBrowser";
import { TRootState } from "../../store/reducers/RootReducer";
import { fetchOrders } from "../../store/action-creators/orders";
import { TOrdersSubState } from "../../store/reducers/orders";

const CustomerOrders = () => {
  const dispatch = useDispatch();
  const ordersState = useSelector<TRootState, TOrdersSubState | undefined>(state => state.orders[-1], shallowEqual);

  useEffect(() => {
    dispatch(fetchOrders());
  }, []);

  if (!ordersState) {
    return null;
  }

  return <OrderList
    orders={ordersState.data}
    loading={!ordersState.error && !ordersState.loadedAt}
    error={Boolean(ordersState.error)}
  />
}

const ORDERS_COMPONENT_BY_USER_TYPE = {
  [UserType.Unknown]: null,
  [UserType.Customer]: CustomerOrders,
  [UserType.CCP]: OrderBrowser,
  [UserType.Admin]: OrderBrowser
}

const Orders = () => {
  const user = useSelector(selectUser);
  const Component = ORDERS_COMPONENT_BY_USER_TYPE[user.type];

  if (!Component) {
    return null;
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <PageTitle title="Orders" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Component />
        </Col>
      </Row>
    </Fragment>
  )
}

export default Orders;
